import { render, staticRenderFns } from "./GestionDepositos.vue?vue&type=template&id=564bf6bf&"
import script from "./GestionDepositos.vue?vue&type=script&lang=js&"
export * from "./GestionDepositos.vue?vue&type=script&lang=js&"
import style0 from "./GestionDepositos.vue?vue&type=style&index=0&id=564bf6bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports